import React from 'react'
import { connect, Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import HasSnackbar from './HasSnackbar'

import RouteProvider from './RouteProvider'
// import Dash from './Dash'
import Dash from './Dashboard'
import Login from './Login'

import Sidebar from './Sidebar'
import ApplicationBar from './ApplicationBar'

import { withStyles } from '@material-ui/core/styles';

import {
  validateToken,
  invalidateUser,
  toggle_mobile,
  toggle_collapse
 } from '../actions/'

import {
  is_logged_on,
  is_validating
} from "../helpers"

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 'calc(100%)',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    height: 64,
    backgroundColor: "#0D223E"
  },
  drawerPaper: {
    overflowX: 'hidden',
    width: '50%',
    transform: 'translateX(-100%)',
    borderRight: 'none',
    height: "100%",
    transition: 'all 0.3s',
    [theme.breakpoints.up('md')]: {
      width: '314px',
      transform: 'none'
    }
  },
  content_nosession: {
    width: '100%',
    paddingTop: '40px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '80px'
    }
  },
  content: {
    transition: 'all .3s',
    position: 'relative',
    minWidth: 0,
    minHeight: '100vh',
    padding: "84px 16px 20px",
    width: '100%',
    boxSizing: "border-box",
    overflow: "visible",
    [theme.breakpoints.up('md')]: {
      left: "314px",
      width: "calc(100% - 314px)",
      padding: "104px 24px 40px", //64 +40
    }
  },
  toolbar: theme.mixins.toolbar,
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    showMobileMenu: state.viewport.showMobileMenu,
    collapseSidebar: state.viewport.collapseSidebar,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    validateToken: () => dispatch(validateToken()),
    invalidateUser: () => dispatch(invalidateUser()),
    toggleMobile: () => dispatch(toggle_mobile()),
    toggleCollapse: () => dispatch(toggle_collapse()),
  };
};

class ConnectedRoot extends HasSnackbar{
  constructor () {
    super()
    window.showSnackbar = this.showSnackbar.bind(this)
    this.state = {
      ...this.state,
      tokenInvalid: false,
      // showMobileMenu: false,
      // collapseSidebar: false
    }
  }
  mobileMenuHandler = () => {
    // this.setState({
    //   showMobileMenu: !this.state.showMobileMenu
    // })
    this.props.toggleMobile()
    document.body.classList.toggle('open-mobile-menu');
  }

  collapseSidebarHandler = () => {
    // this.setState({
    //   collapseSidebar: !this.state.collapseSidebar
    // })
    this.props.toggleCollapse()
    document.body.classList.toggle('collapse-sidebar');
  }

  componentWillMount() {
    const userdata = JSON.parse( localStorage.getItem('userdata') ) || false
    const { invalidateUser, validateToken } = this.props

    if ( userdata === false || userdata === undefined || userdata === null ) {
      invalidateUser()
    } else {
      validateToken()
    }
  }

  componentDidUpdate(prevProps, prevState) {

    const { tokenInvalid } = this.props.auth
    const prevTokenInvalid = prevProps.auth.tokenInvalid

    if ( tokenInvalid !== prevTokenInvalid ) {
      if ( tokenInvalid   ) {
        this.setState({tokenInvalid: true})
      } else {
        this.setState({tokenInvalid: false})
      }
    }

  }

  render() {
    let mainComp;
    let loggedOn

    const { classes } = this.props;


    if ( is_validating() ) {
      return ''
    }

    if ( !is_validating() && !is_logged_on() ) {
      mainComp = Login;
      loggedOn = false
    } else {
      mainComp = Dash;
      loggedOn = true
    }

    return(
      <Provider store={this.props.store}>
        <Router>


          <div className={classes.root}>
            {
              is_logged_on() && (
                <ApplicationBar className={classes.appBar} mobileMenuHandler={this.mobileMenuHandler} mobileMenuIcon={this.props.showMobileMenu} />
              )
            }

            {
              is_logged_on() && (
                <Sidebar classes={classes} loggedOn={loggedOn} mobileMenuHandler={this.mobileMenuHandler} collapseSidebar={this.props.collapseSidebar} collapseSidebarHandler={this.collapseSidebarHandler}/>
              )
            }

            <main className={is_logged_on() ? classes.content : classes.content_nosession}>
              <RouteProvider mainComp={mainComp} loggedOn={is_logged_on()}/>
              {this.SnackBar(this.state.snackbar)}
            </main>


          </div>
        </Router>
      </Provider>
    )
  }
}

const Root = connect(mapStateToProps, mapDispatchToProps)(ConnectedRoot)

export default withStyles(styles)(Root);



// WEBPACK FOOTER //
// ./src/js/components/Root.js